import * as yup from 'yup';
import docs from './attachments';
import {
  nomeBeneficiario,
  nomeMaeBeneficiario,
  nomePaiBeneficiario,
  acao,
  cpfBeneficiario,
  nascimentoBeneficiario,
  consentimentoDadosSensiveisBeneficiario,
} from './utils/rulesByKey';

export const BeneficiarioTaesaSchema = yup.object({
  ...nomeBeneficiario,
  ...cpfBeneficiario,
  ...nascimentoBeneficiario,
  ...nomeMaeBeneficiario,
  ...nomePaiBeneficiario,
  ...consentimentoDadosSensiveisBeneficiario,
  ...acao,
  ...docs.commonDocsBeneficiario.rules,
});

export const BeneficiarioTaesaInitialValues = {
  nomeBeneficiario: '',
  cpf: '',
  nascimento: '',
  nomeMaeBeneficiario: '',
  nomePaiBeneficiario: '',
  consentimentoDadosSensiveis: false,
  acao: '',
  ...docs.commonDocsBeneficiario.initialValues,
};

export const BeneficiarioTaesaDocs = docs.commonsDocs.docs;
